import { useTheme } from 'styled-components';
import { AppTheme } from '../../types';

export const useAppTheme = (): AppTheme => {
  return useTheme() as AppTheme;
};
